/**
 * Feature flags — lists of company IDs that have access to specific features.
 * Add company IDs here to grant access without changing business logic.
 */

export const TREND_SCOUT_COMPANIES = new Set([
  'fbea6992-f36f-4e5d-a383-edf0ae9114ad', // CrewCast (prod)
  '2102f6db-2bb9-4b7e-9c5d-d1bd32d3ddfe', // CrewCast (dev)
]);

export function hasTrendScoutAccess(companyId: string | undefined): boolean {
  return !!companyId && TREND_SCOUT_COMPANIES.has(companyId);
}
